    type MatchResult = {
        totalLength: number;
        segments: number;
    };
      
    export function calculateMatchingIndex(word1: string, word2: string): number {
        const memo = new Map<string, MatchResult>();
        const result = findBestMatch(word1, word2, memo);
        const percent = Number(((result.totalLength / (word1.length > word2.length ? word1.length : word2.length)) * 100).toFixed(2));
        return percent - (result.segments - 1) * 5
    }
      
    function findBestMatch(w1: string, w2: string, memo: Map<string, MatchResult>): MatchResult {
        const key = `${w1}|${w2}`;
        if (memo.has(key)) return memo.get(key)!;
        if (w1.length === 0 || w2.length === 0) return { totalLength: 0, segments: 0 };
      
        let best: MatchResult = { totalLength: 0, segments: 0 };
      
        for (let i = 0; i < w1.length; i++) {
          for (let len = w1.length - i; len > 0; len--) {
            const segment = w1.substring(i, i + len);
            const indexInW2 = w2.indexOf(segment);
            if (indexInW2 !== -1) {
              const remainingW1 = w1.substring(i + len);
              const remainingW2 = w2.substring(indexInW2 + len);
              const nextMatch = findBestMatch(remainingW1, remainingW2, memo);
              const current: MatchResult = {
                totalLength: segment.length + nextMatch.totalLength,
                segments: 1 + nextMatch.segments,
              };
              if (current.totalLength > best.totalLength) {
                best = current;
              }
            }
          }
        }
        memo.set(key, best);
        return best;
    }

    export function stringToNormalizedArrayOfWords(industryName:string): string[] {
        return industryName
            .replace(/[&(),-]/g, ' ')
            .replace(/\s+/g, ' ')
            .trim()
            .toLowerCase()
            .split(' ');
    }